export default class vendorPaymentsPage {
  constructor() {
    $(".vendorPaymentPageSubmit").on("click", this.makeCashfreePayment);
    $(".vendorPaymentCheck").on("click", this.checkCashfreePayment);
  }

  makeCashfreePayment = async () => {
    const dropConfig = {
      components: ["order-details", "card", "netbanking", "app", "upi"],
      onSuccess: this.cashfreePaymentSuccess,
      onFailure: this.cashfreePaymentFailure,
    };

    $.ajax({
      url: baseURL + "api/CashfreePayments/createOrder",
      type: "POST",
      data: {
        Vendor_ID: "67ccb451-4497-11e9-b548-778fd1e3dff0",
        Amount: "100",
        Payment_Type: "Sponsored Payment",
      },
      success: (result) => {
        const responseObj = typeof result === "string" ? JSON.parse(result) : result;
        const paymentSessionId = responseObj["payment_session_id"];
        const mode = responseObj["environment"] || "production";
        
        const cashfree = Cashfree({
          mode: mode
        });
        
        cashfree.checkout({
          paymentSessionId: paymentSessionId,
          redirectTarget: "_self"
        });
      },
      error: (result) => {
        const errObj = typeof result === "string" ? JSON.parse(result) : result;
        console.error("Cashfree Order Creation Failed:", errObj);
      },
    });
  };

  cashfreePaymentSuccess = () => {};

  cashfreePaymentFailure = () => {};

  checkCashfreePayment = async () => {
    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    var payment_order_id = urlParams.get("payment_order_id");

    $.ajax({
      url: baseURL + "api/CashfreePayments/getOrder",
      type: "POST",
      data: {
        Payment_ID: payment_order_id,
      },
      success: (result) => {
        const responseObj = typeof result === "string" ? JSON.parse(result) : result;
        console.log("Payment status checked:", responseObj);
      },
      error: (result) => {
        const errObj = typeof result === "string" ? JSON.parse(result) : result;
        console.error("Payment status check failed:", errObj);
      },
    });
  };
}

